import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * Config for vanilla-cookieconsent (github.com/orestbida/cookieconsent), run once from
 * AppComponent. No real cookies or analytics are set by this app yet — only `necessary`
 * exists today, with `analytics` wired up ready for whenever real tracking is added.
 * At that point, tag the relevant <script> with data-category="analytics" and set
 * manageScriptTags: true below so this library actually gates it, not just displays a banner.
 */
export const COOKIE_CONSENT_CONFIG: CookieConsent.CookieConsentConfig = {
  mode: 'opt-in',
  guiOptions: {
    consentModal: {
      layout: 'bar',
      position: 'bottom',
      equalWeightButtons: true,
    },
    preferencesModal: {
      layout: 'box',
      equalWeightButtons: true,
    },
  },
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {},
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'We use cookies',
          description:
            'We use cookies to keep you signed in and to understand how Avatar Academy is used. See our <a href="#" class="cc__link">Privacy Policy</a> for details.',
          acceptAllBtn: 'Accept',
          acceptNecessaryBtn: 'Decline',
          showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
          title: 'Cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Decline all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Strictly necessary',
              description: 'Required to keep you signed in and for the app to function. Cannot be turned off.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Analytics',
              description: 'Would help us understand how Avatar Academy is used, so we can improve it. Not currently in use.',
              linkedCategory: 'analytics',
            },
          ],
        },
      },
    },
  },
};
